export default "__VITE_ASSET__WKp$zSxu__"